// extracted by mini-css-extract-plugin
export default {"cls1":"dB9JCnK1Y59Mcg1iKsgG","cls2":"WpdjOmVObEjiWuCUMwqw dB9JCnK1Y59Mcg1iKsgG"};